import Keycloak from 'keycloak-js'

const keycloakConfig = {
    url: "https://iam.fpt.vn/auth",
    realm: "fpt",
    clientId: "itsm_portal",
    //clientSecret: "0PwEDJkRwDcBNtxDHBkvX8qpCfOKLJer"
}

const keycloak = new Keycloak(keycloakConfig)

export default keycloak;